import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import settings from './settings'
import reservation from './reservation'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const userState = new createPersistedState({
  paths: ['user'],
})

export default new Vuex.Store({
  modules: {
    user,
    settings,
    reservation,
  },
  plugins: [userState],
  state: {},
  mutations: {},
  actions: {},
})
